export default "__VITE_ASSET__97f2a8a7__"